import { createIconComponent } from '../../factory/create-icon-component';
export const ExcludedIcon = createIconComponent(
  'ExcludedIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 19.1414C6.80375 20.9097 9.27455 22 12 22C17.5228 22 22 17.5228 22 12C22 9.20261 20.8514 6.67349 19 4.85857M5 19.1414C3.14864 17.3265 2 14.7974 2 12C2 6.47715 6.47715 2 12 2C14.7255 2 17.1962 3.09032 19 4.85857M5 19.1414L19 4.85857"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
